<template>
  <ExecutionPeriodRadioField
    field="custom-dimension-1"
    :choices="choices"
    v-on="$listeners"
  />
</template>

<script>
import { Selectable } from 'chimera/all/components/models/Selectable'
import ExecutionPeriodRadioField from 'chimera/all/components/form/fields/executionPeriod/ExecutionPeriodRadioField.vue'

export default {
  name: 'ExecutionPeriodRadioFormPart',

  components: {
    ExecutionPeriodRadioField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        'within-1-month',
        '1-to-3-months',
        '3-to-6-months',
        'more-than-6-months',
        'in-consultation',
      ].map((key) => {
        const label = this.$i18n.t(`field.execution-period.options.${key}`)
        return new Selectable(label, label, label)
      }),
    }
  },
}
</script>
